export default __webpack_public_path__ + "static/media/image1.0fbbe8aa.jpeg";